import participantesAtividadeService from "@/service/participantesAtividadeService";
import { usePagination } from "@/composables/usePagination";
import { ref } from "vue";

export function useParticipantesAtividade() {
  const participantes = ref([]);
  const atividadesParticipante = ref([]);
  const inscritos = ref([]);
  const isInscrito = ref(false);

  const isLoading = ref(false);
  const isSaving = ref(false);

  const pagination = usePagination({
    initialPage: 0,
    pageSize: 10,
    baseIndex: 0,
  });

  const fetchAtividadesParticipante = async (
    page = pagination.currentPage.value,
    size = pagination.pageSize.value,
    usuarioId
  ) => {
    isLoading.value = true;
    try {
      const response =
        await participantesAtividadeService.getAtividadesParticipante(
          page,
          size,
          usuarioId,
          true
        );
      if (response) {
        atividadesParticipante.value = response.atividades || [];
        pagination.setPaginationInfo(response);
        pagination.currentPage.value = page;
      }
      return response;
    } catch (error) {
      console.error("Erro ao buscar atividades do participante:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const fetchParticipantesAtividade = async (
    page = pagination.currentPage.value,
    size = pagination.pageSize.value,
    atividadeId
  ) => {
    isLoading.value = true;
    try {
      const response =
        await participantesAtividadeService.getParticipantesAtividade(
          page,
          size,
          atividadeId
        );
      participantes.value = response || [];
      pagination.currentPage.value = page;
      return response;
    } catch (error) {
      console.error("Erro ao buscar participantes da atividade:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const inscreverParticipante = async (atividadeId) => {
    isSaving.value = true;
    try {
      const response =
        await participantesAtividadeService.postParticipanteAtividade(
          atividadeId
        );
      return response;
    } catch (error) {
      console.error("Erro ao inscrever participante:", error);
    } finally {
      isSaving.value = false;
    }
  };

  const removerInscricao = async (participanteId) => {
    isLoading.value = true;
    try {
      const response =
        await participantesAtividadeService.removerInscricao(participanteId);
      return response;
    } catch (error) {
      console.error("Erro ao remover participante:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const cancelarInscricao = async (atividadeId) => {
    isLoading.value = true;
    try {
      const response =
        await participantesAtividadeService.cancelarInscrição(atividadeId);
      return response;
    } catch (error) {
      console.error("Erro ao cancelar inscrição:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const desinscreverUsuario = async (atividadeId, user) => {
    isLoading.value = true;
    try {
      const response = await participantesAtividadeService.desinscreverUsuario(
        atividadeId,
        user
      );
      return response;
    } catch (error) {
      console.error("Erro ao desinscrever usuário:", error);
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  const checkUsuarioLogadoInscrito = async (atividadeId) => {
    try {
      const response =
        await participantesAtividadeService.isUsuarioLogadoInscrito(
          atividadeId
        );
      isInscrito.value = Boolean(response);
      return response;
    } catch (error) {
      console.error("Erro ao verificar inscrição do usuário logado:", error);
      isInscrito.value = false;
      return false;
    }
  };

  const fetchInscritosByAtividade = async (atividadeId) => {
    isLoading.value = true;
    try {
      const response =
        await participantesAtividadeService.getInscritosByAtividade(
          atividadeId
        );
      inscritos.value = response || [];
      return response;
    } catch (error) {
      console.error("Erro ao buscar inscritos da atividade:", error);
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    participantes,
    atividadesParticipante,
    inscritos,
    isInscrito,
    isLoading,
    isLoadingParticipante: isLoading,
    isSaving,
    isSavingParticipante: isSaving,
    currentPage: pagination.currentPage,
    totalPages: pagination.totalPages,
    pageSize: pagination.pageSize,
    hasNextPage: pagination.hasNextPage,
    hasPreviousPage: pagination.hasPreviousPage,
    fetchAtividadesParticipante,
    fetchParticipantesAtividade,
    inscreverParticipante,
    removerInscricao,
    cancelarInscricao,
    desinscreverUsuario,
    checkUsuarioLogadoInscrito,
    fetchInscritosByAtividade,
    nextPage: pagination.nextPage,
    previousPage: pagination.previousPage,
    goToPage: pagination.goToPage,
  };
}
